import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../app/appSlice';
import { updateUserPreferences } from './actions/userPreferencesAPIs';
import { TInitialState } from './types';

export const initialState: TInitialState = {
  settings: {
    vrr: {
      language: 'en',
      period: {
        from: undefined,
        to: undefined
      },
      current_account_id: null,
      custom_labels_list: null
    },
    overview: {
      global_metrics: [],
      global_insights: []
    },
    insights: {
      filters: [],
      cards: []
    }
  }
};

export const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateUserPreferences.fulfilled, (state, { payload }) => {
      return {
        ...state,
        settings: {
          ...payload.settings
        }
      };
    });
    builder.addCase(logout, () => {
      return {
        ...initialState
      };
    });
  }
});
export default userPreferencesSlice.reducer;
